import { render, staticRenderFns } from "./ResultsCombination.vue?vue&type=template&id=7095ffd1&"
import script from "./ResultsCombination.vue?vue&type=script&lang=js&"
export * from "./ResultsCombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports